var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4901 37.0273L49.9958 44.6319M40.4901 37.0273V71.2479V37.0273ZM40.4901 37.0273L30.9844 44.6319L40.4901 37.0273Z",
    stroke: "#828282",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0035 26.0664C10.4073 26.9713 7.26538 29.1583 5.16795 32.2164C3.07051 35.2745 2.16197 38.9932 2.61302 42.674C3.06406 46.3547 4.84365 49.744 7.61742 52.2052C10.3912 54.6664 13.9682 56.03 17.6765 56.0398H21.4788",
    stroke: "#828282",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.053 18.5422C53.7534 13.3961 50.5457 8.93663 46.0801 6.06787C41.6145 3.19911 36.2251 2.13568 31.0045 3.09314C25.7839 4.05061 21.1227 6.95733 17.9658 11.2241C14.8088 15.4908 13.3924 20.7983 14.0035 26.0707C14.0035 26.0707 14.5853 29.4243 15.7754 31.3254",
    stroke: "#828282",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5016 56.0404C62.1861 56.0386 64.8398 55.4682 67.2881 54.3669C69.7363 53.2655 71.9236 51.6581 73.7058 49.6506C75.4881 47.643 76.825 45.2807 77.6285 42.7192C78.432 40.1577 78.6839 37.4551 78.3676 34.7892C78.0513 32.1234 77.1741 29.5547 75.7935 27.2523C74.413 24.9499 72.5605 22.966 70.358 21.4312C68.1554 19.8964 65.6528 18.8454 63.0148 18.3475C60.3769 17.8495 57.6633 17.9159 55.0529 18.5423L49.9958 19.9187",
    stroke: "#828282",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.577451ca0224caafb00c956a4b4d9e87.svg";
export { ForwardRef as ReactComponent };